import script from "./semanaCalendarioNovo.vue?vue&type=script&setup=true&lang=js"
export * from "./semanaCalendarioNovo.vue?vue&type=script&setup=true&lang=js"

import "./semanaCalendarioNovo.vue?vue&type=style&index=0&id=25593ab2&lang=css"

const __exports__ = script;

export default __exports__